export default [
    'bis',
    'durch',
    'entlang',
    'für',
    'gegen',
    'ohne',
    'um',
    'wider'
];